export default __webpack_public_path__ + "static/media/d2.c093ab80.svg";